import Image from "next/image";
import graduation from "@/public/doctors-images/graduation-cap.png";
import location from "@/public/doctors-images/location.png";

function DoctorsGraduation(props) {
  console.log("props?.location;", props?.location);
  return (
    <div className="mt-6">
      {props?.graduation ? (
        <>
          <div className="flex flex-row gap-2 items-center">
            <Image
              src={graduation}
              width={22}
              height={22}
              alt="graduation cap"
              title="graduation cap"
            />
            <p className="p-text text-primaryBlack">{props.graduation}</p>
          </div>
        </>
      ) : null}
      {props?.location?.length > 0
        ? props?.location?.map((singlelocation) => (
            <div
              key={singlelocation.id}
              className="flex flex-row gap-2 mt-2 items-center"
            >
              <Image
                src={location}
                width={22}
                height={22}
                alt="location"
                title="location"
              />
              <p className="p-text text-primaryBlack">
                {singlelocation?.attributes?.locationCity}
              </p>
            </div>
          ))
        : null}
    </div>
  );
}

export default DoctorsGraduation;
